"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _reactRedux = require("react-redux");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Modal = _interopRequireDefault(require("../common/Modal/Modal"));
var _modalDecorator = _interopRequireDefault(require("../../hocs/modalDecorator"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _APLabelWithText = _interopRequireDefault(require("../common/APLabelWithText"));
var _APButton = _interopRequireDefault(require("../common/APButton"));
require("./MarginClosePositionModal.css");
var _actions = require("../../redux/margin/actions");
var _modalActions = require("../../redux/actions/modalActions");
var _marginActions = require("../../redux/margin/actions/marginActions");
var _numberFormatter = require("../../helpers/numberFormatter");
var _productsSelectors = require("../../redux/selectors/productsSelectors");
var _MarginAssetOptionsDnd = _interopRequireDefault(require("../MarginAssetOptionsDnd/MarginAssetOptionsDnd"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var bemClasses = (0, _cssClassesHelper.getBEMClasses)('confirm-order-modal');
var formatMoney = function formatMoney(value, _ref) {
  var DecimalPlaces = _ref.DecimalPlaces,
    Product = _ref.Product;
  return "".concat((0, _numberFormatter.formatNumberToLocale)(value, DecimalPlaces || Product), " ").concat(Product);
};
var MarginClosePositionModal = function MarginClosePositionModal(props) {
  var _position$instrument;
  var _useTranslation = (0, _reactI18next.useTranslation)('margin'),
    t = _useTranslation.t;
  var isOpen = props.isOpen,
    close = props.close,
    position = props.position,
    closeMarginPosition = props.closeMarginPosition,
    cancelMarginPosition = props.cancelMarginPosition,
    notionalProduct = props.notionalProduct,
    action = props.action,
    repaymentAssetOptions = props.repaymentAssetOptions,
    getRepaymentAssetOptions = props.getRepaymentAssetOptions;
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    repaymentOptions = _useState2[0],
    setRepaymentOptions = _useState2[1];
  var prevRepaymentAssetOptionsRef = (0, _react.useRef)();
  var baseNotionalDecimalPlaces = notionalProduct.DecimalPlaces;
  (0, _react.useEffect)(function () {
    getRepaymentAssetOptions(position === null || position === void 0 ? void 0 : position.PositionId);
  }, [position, getRepaymentAssetOptions]);
  (0, _react.useEffect)(function () {
    var repaymentOptionsChanged = JSON.stringify(prevRepaymentAssetOptionsRef.current) !== JSON.stringify(repaymentAssetOptions);
    if (Array.isArray(repaymentAssetOptions) && repaymentOptionsChanged) {
      setRepaymentOptions(repaymentAssetOptions);
      prevRepaymentAssetOptionsRef.current = repaymentAssetOptions;
    }
  }, [repaymentAssetOptions]);
  var closeDetailsMsgOne = (0, _react.useMemo)(function () {
    if (!position) return null;
    var BaseProductSymbol = position.BaseProductSymbol,
      QuoteProductSymbol = position.QuoteProductSymbol;
    return (position === null || position === void 0 ? void 0 : position.PositionType) === 'Long' ? t("First, we will sell {{BaseProductSymbol}} for {{QuoteProductSymbol}} to reduce position size", {
      BaseProductSymbol: BaseProductSymbol,
      QuoteProductSymbol: QuoteProductSymbol
    }) : t("First, we will buy {{BaseProductSymbol}} with {{QuoteProductSymbol}} to reduce position size", {
      BaseProductSymbol: BaseProductSymbol,
      QuoteProductSymbol: QuoteProductSymbol
    });
  }, [position, t]);
  var isDisabled = (0, _react.useMemo)(function () {
    return !repaymentOptions.some(function (item) {
      return item.checked;
    });
  }, [repaymentOptions]);
  var onAssetOptionsOrderChange = (0, _react.useCallback)(function (newOrder) {
    setRepaymentOptions(newOrder);
  }, []);
  var onCheckboxChange = (0, _react.useCallback)(function (id) {
    setRepaymentOptions(function (prevOptions) {
      var updatedRepaymentOptions = prevOptions.map(function (item) {
        return item.id === id ? _objectSpread(_objectSpread({}, item), {}, {
          checked: !item.checked
        }) : item;
      });
      return updatedRepaymentOptions;
    });
  }, []);
  if (!isOpen || !position) return null;
  var items = [{
    label: "".concat(t('Pair'), ":"),
    text: (_position$instrument = position.instrument) === null || _position$instrument === void 0 ? void 0 : _position$instrument.Symbol
  }, {
    label: "".concat(t('Type'), ":"),
    text: position.PositionType
  }, {
    label: "".concat(t('Size'), ":"),
    text: formatMoney(position.PositionAmount, position.positionProduct)
  }, {
    label: "".concat(t('Cost Basis'), ":"),
    text: formatMoney(position.CostBasis, position.quoteProduct)
  }, {
    label: "".concat(t('Position Value'), ":"),
    text: formatMoney(position.PositionValue, position.quoteProduct)
  }, {
    label: "".concat(t('Interest Accrued'), ":"),
    text: formatMoney(position.RemainingInterest || position.Interest || 0, position.PositionType === 'Long' ? position.borrowedProduct : position.positionProduct)
  }, {
    label: "".concat(t('Unrealized P&L'), ":"),
    text: formatMoney(position.UnrealizedPnL, notionalProduct)
  }, {
    label: "".concat(t('Remaining Liability'), ":"),
    text: formatMoney(position.RemainingLiability || position.Liability || 0, position.PositionType === 'Long' ? position.borrowedProduct : position.positionProduct)
  }];
  var handleClosePositionSubmit = function handleClosePositionSubmit() {
    var checkedOptions = repaymentOptions.filter(function (item) {
      return item.checked;
    });
    var productIds = checkedOptions.map(function (product) {
      return product.ProductId;
    });
    closeMarginPosition(productIds);
    close();
  };
  var handleCancelPositionSubmit = function handleCancelPositionSubmit() {
    cancelMarginPosition();
    close();
  };
  var filteredItems = action === 'cancel' ? items.slice(0, -1) : items;
  return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    isOpen: isOpen,
    title: t(action === 'cancel' ? 'Cancel Position' : 'Close Position'),
    onCancel: close,
    close: close
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "position-details-title"
  }, "Position Details"), /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses()
  }, filteredItems.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
      key: item.label,
      label: item.label,
      text: item.text,
      customClass: bemClasses()
    });
  }), action === 'cancel' && /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('info')
  }, t("This position is not associated with any loan and can be canceled without further trading. Once canceled, the position's unrealized P&L will no longer be updated.")), action === 'close' && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h4", {
    className: "repayment-details-title"
  }, "Loan Repayment Details"), /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('close-disclaimer-container')
  }, /*#__PURE__*/_react["default"].createElement("ul", {
    className: bemClasses('close-disclaimer-list')
  }, /*#__PURE__*/_react["default"].createElement("li", {
    className: bemClasses('info-row-1')
  }, closeDetailsMsgOne), /*#__PURE__*/_react["default"].createElement("li", {
    className: bemClasses('info-row-2')
  }, t("Next, we will repay any remaining liability using your collateral assets in the following order:")))), /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('repay-list-container')
  }, /*#__PURE__*/_react["default"].createElement(_MarginAssetOptionsDnd["default"], {
    repaymentOptions: repaymentOptions,
    onAssetOptionsOrderChange: onAssetOptionsOrderChange,
    onCheckboxChange: onCheckboxChange,
    baseNotionalDecimalPlaces: baseNotionalDecimalPlaces
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('buttons')
  }, /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
    type: "button",
    styleName: "additive",
    disabled: isDisabled,
    onClick: action === 'cancel' ? handleCancelPositionSubmit : handleClosePositionSubmit
  }, action === 'cancel' ? t('Confirm') : t('Submit')))));
};
MarginClosePositionModal.defaultProps = {
  handleSubmit: function handleSubmit() {},
  submitting: false
};
MarginClosePositionModal.propTypes = {
  close: _propTypes["default"].func.isRequired,
  handleSubmit: _propTypes["default"].func
};
var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    closeMarginPosition: function () {
      var _closeMarginPosition2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(repaymentAssets) {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return dispatch((0, _actions.closeMarginPosition)(ownProps.position, repaymentAssets));
            case 1:
              dispatch((0, _marginActions.refreshMarginAccountInfo)());
              dispatch((0, _actions.refreshMarginAccountEquity)());
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      function closeMarginPosition(_x) {
        return _closeMarginPosition2.apply(this, arguments);
      }
      return closeMarginPosition;
    }(),
    cancelMarginPosition: function () {
      var _cancelMarginPosition2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return dispatch((0, _actions.cancelMarginPosition)(ownProps.position));
            case 1:
              dispatch((0, _marginActions.refreshMarginAccountInfo)());
              dispatch((0, _actions.refreshMarginAccountEquity)());
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      function cancelMarginPosition() {
        return _cancelMarginPosition2.apply(this, arguments);
      }
      return cancelMarginPosition;
    }(),
    getRepaymentAssetOptions: function () {
      var _getRepaymentAssetOptions2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(positionId) {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return dispatch((0, _actions.getRepaymentAssetOptions)(positionId));
            case 1:
              return _context3.a(2);
          }
        }, _callee3);
      }));
      function getRepaymentAssetOptions(_x2) {
        return _getRepaymentAssetOptions2.apply(this, arguments);
      }
      return getRepaymentAssetOptions;
    }()
  };
};
var mapStateToProps = function mapStateToProps(state) {
  var repaymentAssetOptions = state.margin.history.repaymentAssetOptions;
  var decimalPlaces = (0, _productsSelectors.decimalsByProductId)(state);
  var modifiedRepaymentAssetOptions = repaymentAssetOptions.map(function (item) {
    return _objectSpread(_objectSpread({}, item), {}, {
      id: item.ProductId,
      DecimalPlaces: decimalPlaces[item.ProductId] || 8,
      checked: true
    });
  });
  return {
    notionalProduct: (0, _productsSelectors.baseNotionalProductSelector)(state),
    repaymentAssetOptions: modifiedRepaymentAssetOptions
  };
};
var container = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(MarginClosePositionModal);
var _default = exports["default"] = (0, _modalDecorator["default"])({
  name: _modalActions.MODAL_TYPES.MARGIN_CLOSE_POSITION
})(container);